import { render, staticRenderFns } from "./AddToCartButtonTab.vue?vue&type=template&id=4fecf010"
import script from "./AddToCartButtonTab.vue?vue&type=script&lang=js"
export * from "./AddToCartButtonTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports